import { render, staticRenderFns } from "./PayrollProjectInfo.vue?vue&type=template&id=fe00d8f2&scoped=true&"
import script from "./PayrollProjectInfo.vue?vue&type=script&lang=js&"
export * from "./PayrollProjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./PayrollProjectInfo.vue?vue&type=style&index=0&id=fe00d8f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe00d8f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VChip,VCol,VRow,VSheet})
